var toString = Object.prototype.toString

module.exports = isString

function isString(obj) {
    return toString.call(obj) === "[object String]"
}



//////////////////
// WEBPACK FOOTER
// ./~/x-is-string/index.js
// module id = 577
// module chunks = 168707334958949